import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_ROUTER, DEFAULT_ADMIN_PAGE, DEFAULT_PARKING_PAGE, DEFAULT_EMPLOYEE_PAGE } from './shared/constants/app-router';
import { MsalGuard } from '@azure/msal-angular';
import { CentralGuard } from 'src/app/core/guards/central.guard';
import { ParkingsComponent } from 'src/app/modules/parkings/pages/parkings.component';
import { MessagesComponent} from 'src/app/modules/messages/components/messages.component';
import { BlankComponent } from './modules/blank/blank.component';
import { USER_ROLE } from './shared/enum/role.enum';
import { AuthGuard } from './core/guards/auth.guard';


const routes: Routes = [
	{
		path: APP_ROUTER.EMPLOYEE,
		loadChildren: () =>
			import('./modules/employee/employee-portal.module').then(m => m.EmployeePortalModule),
			canActivate: [CentralGuard, MsalGuard],
    canActivateChild: [CentralGuard],
    data: {
      allowedRole: USER_ROLE.EMPLOYEE,
    },
	},
	{
		path: APP_ROUTER.ADMIN,
		loadChildren: () =>
			import('./modules/admin/admin.module').then(m => m.AdminModule),
			canActivate: [CentralGuard, MsalGuard],
			canActivateChild: [CentralGuard],
	},
	{
		path: APP_ROUTER.CLAIMS,
		loadChildren: () =>
			import('./modules/claim/claim.module').then(m => m.ClaimModule),
			canActivate: [CentralGuard, MsalGuard],
			canActivateChild: [CentralGuard],
		},
	{
		path: APP_ROUTER.HELP_LINK,
		loadChildren: () =>
			import('./modules/help-link/help-link.module').then(m => m.HelpLinkModule),
	},
	{
		path: APP_ROUTER.PARKINGS,
		component: ParkingsComponent,
		loadChildren: () =>
			import('./modules/parkings/parkings.module').then(m => m.ParkingsModule),
		canActivate: [CentralGuard],
		canActivateChild: [CentralGuard],
	},
	{
		path: APP_ROUTER.MESSAGES,
		component: MessagesComponent,
		loadChildren: () =>
			import('./modules/messages/messages.module').then(m => m.MessagesModule),
	},
	{
    path: '',
    redirectTo: APP_ROUTER.EMPLOYEE,
    pathMatch: 'full'
		//component: BlankComponent,
		//redirectTo: APP_ROUTER.MESSAGES,
	},
	{
		path: '**',
		//redirectTo: `${APP_ROUTER.MESSAGES}?msgid=ERRORS.PAGE_NOT_FOUND`,
		component: MessagesComponent,
    //canActivate: [CentralGuard],
    canActivate: [AuthGuard],
	},
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: true,
    initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled' // Don't perform initial navigation in iframes
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
